import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Component, ElementRef, ViewChild, Inject, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { Injectable, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';


import { HttpClient } from '@angular/common/http';

import { ActivatedRoute } from '@angular/router';
import { SpinnerOverlayService } from '../../../../services/spinner-overlay.service';
import { UMPCategory, Utils } from '../../../../utils/utils';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';



@Component({
    selector: "group-umpbranchhierarchy",
    templateUrl: './umpbranchhierarchy.component.html',
    styleUrls: ['./umpbranchhierarchy.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class GroupUMPBranchHierarchy implements OnInit {
    @Input() reload: boolean = false;
    dataCopy: any;
    userId = '';
    public TREE_DATA: UMPBranchNode[] = [];/*** */

    public selectedNodes: string[] = [];

    public treeControl: NestedTreeControl<UMPBranchNode>;
    public dataSource = new MatTreeNestedDataSource<UMPBranchNode>();

    public searchString = '';
    public showOnlySelected = false;

    Tree_Response_State: number = -2; //0 -> empty , 1 -> correct and not empty ,-1 -> error, -2 -> Calling API

    isCallSucceed: number = 0;
    secTenantSet = new Set<string>();

    data: TreeManagement<UMPCategory> = {
        SelectedBranches: [],
        UnselectedBranches: [],
        UmpCategory: UMPCategory.BranchHierarchy
    }
    constructor(
        private toastrService: ToastrService,
        private route: ActivatedRoute,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private spinnerOverlayService: SpinnerOverlayService,
        private defaults: DefaultValuesService
        ) {
        this.treeControl = new NestedTreeControl<UMPBranchNode>((node) => node.children)
        defaults.resetBulkGroupTrigger$.subscribe(() => this.resetData())

    }
    ngOnInit() {
        this.userId = this.route.snapshot.paramMap.get('userId') || '';
        this.funcGetUserBranches();

    }

    ngOnChanges() {
        if (this.userId !== '')
            this.funcGetUserBranches();
    }


    public hasChild = (_: number, node: UMPBranchNode) =>
        !!node.children && node.children.length > 0;

    private setParent(node: UMPBranchNode, parent: UMPBranchNode | undefined) {
        node.parent = parent;
        if (node.children) {
            node.children.forEach((childNode) => {
                this.setParent(childNode, node);
            });
        }
    }

    private checkAllParents(node: UMPBranchNode) {
        if (node.parent) {
            const descendants = this.treeControl.getDescendants(node.parent);
            node.parent.indeterminate = descendants.some((child) => child.selected);
            this.checkAllParents(node.parent);
        }
    }

    public itemToggle(checked: boolean, node: UMPBranchNode) {
        this.searchTenant(checked, node);

        node.selected = checked;
        if (node.children && checked) {
            node.indeterminate = false;
            this.itemUnselect(node);

        }
        if (node.children) {
            this.itemDisable(checked, node);
        }
        if (checked) {
            this.data.UnselectedBranches = this.data.UnselectedBranches.filter(x => x !== node.id)
            this.data.SelectedBranches.push(node.id)
        }
        else {
            this.data.SelectedBranches = this.data.SelectedBranches.filter(x => x !== node.id)
            this.data.UnselectedBranches.push(node.id)
        }
        this.checkAllParents(node);
    }
    private searchTenant(checked: boolean, node: UMPBranchNode) {
        if (node.isTenantNode) {
            this.updateTenSet({ selTen: [this.extractText(node.text)], checked });
        }
        else {
            this.searchTenantInDesc(checked, node);
        }
    }
    private searchTenantInDesc(checked: boolean, node: UMPBranchNode) {
        const descendants = this.treeControl.getDescendants(node);
        var tenNode = descendants.filter(node => node.isTenantNode);
        if (tenNode.length > 0) {
            var selTen = tenNode.map((node) => this.extractText(node.text))
            this.updateTenSet({ selTen, checked });
        }
        else {
            this.searchTenantInParent(checked, node);
        }
    }
    extractText = (input: string) =>
        input.replace(/\s+/g, '').split('(')[0];

    private searchTenantInParent(checked: boolean, node: UMPBranchNode) {
        if (node.parent) {
            node.parent.isTenantNode ? (this.updateTenSet({ selTen: [this.extractText(node.parent.text)], checked })) : null;
            this.searchTenantInParent(checked, node.parent);
        }
    }
    private updateTenSet(eventData: { selTen: string[], checked: boolean }) {
        eventData.selTen.forEach((ten) => { eventData.checked ? this.defaults.secondaryTenList.add(ten) : this.secTenantSet.delete(ten) })
    }
    private itemUnselect(node: UMPBranchNode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach(node => { node.indeterminate = false; node.selected = false });
    }

    private itemDisable(checked: boolean, node: UMPBranchNode) {
        const descendants = this.treeControl.getDescendants(node);
        descendants.forEach(node => node.disabled = checked);
    }

    submit() {
        this.spinnerOverlayService.setFalseskipInterceptor()
        Utils.httpPostTreeGroupsByType(
            this.http
            , this.baseUrl
            , this.data
            , this.userId
            , this
            , function (tthis: GroupUMPBranchHierarchy, data: any) {
                tthis.data.SelectedBranches = []
                tthis.data.UnselectedBranches = []
                tthis.spinnerOverlayService.setTrueskipInterceptor()
                tthis.funcNotify();
                tthis.funcGetUserBranches();
            }
        )

    }

    public hideLeafNode(node: UMPBranchNode): boolean {
        return new RegExp(this.searchString, 'i').test(node.text) === false;
    }


    public hideParentNode(node: UMPBranchNode): boolean {
        if (
            !this.searchString ||
            node.text.toLowerCase().indexOf(this.searchString.toLowerCase()) !==
            -1
        ) {
            return false
        }
        const descendants = this.treeControl.getDescendants(node)

        if (
            descendants.some(
                (descendantNode) =>
                    descendantNode.text
                        .toLowerCase()
                        .indexOf(this.searchString.toLowerCase()) !== -1
            )
        ) {
            return false
        }

        return true
    }
    funcGetUserBranches() {
        this.Tree_Response_State = -2;
        this.TREE_DATA.splice(0, this.TREE_DATA.length)
        Utils.httpGetBranches(
            this.http
            , this.baseUrl
            , this
            , (tthis: GroupUMPBranchHierarchy, data: any) => {

                this.dataCopy = structuredClone(data);
                this.assignValues(data)


            });
    }
    assignValues(data) {
        this.TREE_DATA = [data.rootTenantNodes];

        this.treeControl.dataNodes = this.TREE_DATA;
        this.dataSource.data = this.TREE_DATA;
        //tthis.selectedNodes = data.rootTenantNodes;
        Object.keys(this.dataSource.data).forEach((key) => {
            this.setParent(this.dataSource.data[key], undefined);

        }
        )
    }
    resetData() {
        this.assignValues(structuredClone(this.dataCopy))
    }


    funcNotify() {
        if (this.isCallSucceed === 1) {
            this.toastrService.success('Update Branch Hierarchy request sent successfully !', 'Update Branch Hierarchy Request!');
        }
        else if (this.isCallSucceed === -1) {
            this.toastrService.error('Update Branch Hierarchy request not sent successfully !', 'Update Branch Hierarchy Request!');
        }
    }

    itemSelected(ischecked,name,id) {
        if (ischecked) {
            this.onSelect(name, id);
        } else {
            this.onDeselect(name, id);
        }
    }

    onSelect(name, selectedid) {
        this.defaults.addGroupListItem({ Personae: name, Id: selectedid, UmpCategory: UMPCategory.BranchHierarchy });

    }

    onDeselect(name, selectedid) {
        this.defaults.removeGroupListItem(selectedid);

    }
}